module.exports = "<div class=wrapper ng-if=!!$ctrl.hotelSearchResults.HotelsCountInExtendedRadius><div class=text><l10n>There are up to</l10n>&nbsp; <span ng-bind=$ctrl.hotelSearchResults.HotelsCountInExtendedRadius></span>&nbsp;<l10n>extra hotels in</l10n>&nbsp; <span ng-bind=$ctrl.getNextRadius()></span> <span kt-distance-unit=\"\" kt-distance-unit-to-long-form=::true></span> radius</div><span class=button ng-click=$ctrl.onShowMoreClicked()><l10n>Show more</l10n></span></div>";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/hotels/extra-hotels/extra-hotels.html
// module id = 3222
// module chunks = 0